<template>
    <b-badge pill :variant="variant" v-if="overdue !== 0">
        {{ date }}
    </b-badge>
    <span v-else>
      {{ date }}
    </span>
</template>

<script>
export default {
  props: {
    overdue: {
      type: Number,
      required: true,
      validator: (val) => [0, 1, 2].includes(val)
    },
    date: {
      required: true,
      validator: (val) => typeof val === 'string' || val === null
    }
  },
  computed: {
    variant () {
      const variants = {
        1: 'warning',
        2: 'danger'
      }

      return variants[this.overdue]
    }
  }
}
</script>

<style scoped>
    .badge {
        font-weight: normal;
    }
</style>
